/**
 * Typed search params for the `/clients` route (the reports/invoices/estimates
 * pattern). `?q=<text>` is the server-side search — the endpoint takes `q`, so
 * the text goes over the wire rather than being filtered in memory, and the URL
 * stays deep-linkable + back-button friendly.
 */

export interface ClientsSearch {
  q?: string;
}

/** Coerce a raw URL value into a trimmed, length-capped search string (else undefined). */
function asQuery(value: unknown): string | undefined {
  if (typeof value !== 'string') return undefined;
  const trimmed = value.trim().slice(0, 100);
  return trimmed.length > 0 ? trimmed : undefined;
}

/**
 * TanStack Router `validateSearch` for the clients list route. Keeps the search
 * text only when non-empty, so the canonical URL stays clean (`/clients` vs
 * `/clients?q=acme`).
 */
export function validateClientsSearch(raw: Record<string, unknown>): ClientsSearch {
  const search: ClientsSearch = {};
  const q = asQuery(raw.q);
  if (q) search.q = q;
  return search;
}
